// Converts an HTML string to plain text by stripping all tags.
// Newlines are injected before <br> and closing block tags so adjacent
// elements are separated (e.g. "<td>Drug</td><td>A</td>" → "Drug\nA").
// DOMParser + textContent decodes HTML entities, and a final whitespace
// collapse cleans up any consecutive newlines.
export function htmlToPlainText(html: string): string {
  const newlinedHtml = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(?:p|div|tr|td|th|li|h[1-6])>/gi, '\n')

  return (new DOMParser().parseFromString(newlinedHtml, 'text/html').body.textContent ?? '')
    .replace(/\n+/g, '\n') // collapse multiple consecutive newlines
    .trim()
}
